<div class="day-cell">
  <span class="day-number">{{ dayNumberText() }}</span>
  @if (editable()) {
    <button class="add-button" (click)="add.emit(date())">+</button>
  }
</div>
